import { Component, Input } from '@angular/core';
import { WhiskeyItem } from '../../menu.model'

@Component({
  selector: 'scotch',
  templateUrl: './scotch.component.html',
  styleUrls: ['./scotch.component.scss']
})
export class ScotchComponent {

  @Input() whiskeyList: Array<WhiskeyItem> = [];
  @Input() activeSection: string | undefined;

  constructor() {}

}
